import React, { useState } from "react";
import { get } from "lodash";

import { getIcon } from "../../../../helpers/icons";
import Details from "./Details";
import Link from "../../../../components/Link";
import Title from "../../../../components/Title";
import Editor from "../../../../components/Editor";
import Spacer from "../../../../components/Spacer";
import DialogBox from "../../../../components/DialogBox";
import ChangePlanDialogBox from "../../../../components/DialogBox/ChangePlan";
// import AsyncGet from "../../../../components/AsyncGet";

import style from "../style.module.css";

export default function ChangePlan(props) {

    const {
        userProfile = {},
        planDetailsFromApi={}
    } = props;

    const [popup, setPopup] = useState(false);

    return (
        <>
            <div className={style.changePlan}>
                <Title className="fontTeko" tag="h5" transform="uppercase">
                    {get(planDetailsFromApi, 'full_title', '')}
                </Title>
                <Editor text={get(planDetailsFromApi, 'description', '')} />
                <Spacer />
                <Details
                    userProfile={userProfile}
                    planDetailsFromApi={planDetailsFromApi}
                />
                <div className={style.bigButton}>
                    <Link to="benefits">Membership benefits <span><i className={getIcon('Chevronright')}></i></span></Link>
                </div>
                {/* <AsyncGet
                    url="/membership"
                    permissionText={false}
                    paramsData={{ limit: -1 }}
                    loadOnMount={true}
                    render={({ data }) => {
                        if (!data || !Array.isArray(data.list)) return null;
                        const selectedPlan = data.list.find(item =>
                            (get(userProfile, 'membership.membership_id') !== item.id)
                        );
                        return selectedPlan ? (
                            <div className={style.bigBtn} onClick={() => setPopup("changePlan")}>
                                Change plan <span><i className={getIcon("Chevronright")}></i></span>
                            </div>
                        ) : null;
                    }}
                /> */}
            </div>
            {popup === "changePlan" && (
                <DialogBox
                    onClose={() => setPopup(false)}
                    className={style.articlePopup}
                    title={false}
                    headerClass={style.dialogBoxHeader}
                    modalClassName={style.articleModal}
                    buttonClassName={style.customCloseStyle}
                    hasCloseIcon={false}
                    render={({ closeDialog }) => (
                        <ChangePlanDialogBox userProfile={userProfile} closeDialog={closeDialog} />
                    )}
                />
            )}
        </>
    );
}
